import {takeEvery} from 'redux-saga/effects';
import {NetworkActionTypes} from "@fkhplus/common/src/modules/network/actions";
import {IFluxStandardAction} from '@fkhplus/common/src/modules/interfaces';
import {ISetNetworkResponse} from '@fkhplus/common/src/modules/network/interfaces';
import { Logger } from '@fkhplus/common/src/utils/logger';

function* networkFetch(action: IFluxStandardAction<ISetNetworkResponse>): Generator {
    Logger.info(action.type)
}

function* watchNetworkSagas(): Generator {
    yield takeEvery(NetworkActionTypes.IS_CONNECTED, networkFetch)
}

export default watchNetworkSagas;